import moment from 'moment'
import {
  CLEAR_FILTERS,
  DELETE_FILTER,
  DELETE_FILTER_ITEM,
  SET_APPLIED_FILTER,
  SET_FILTER,
  LOAD_SUBREQUESTS_BY_REQUEST_ID,
  LOAD_SUBREQUESTS_BY_REQUEST_ID_SUCCESS,
  LOAD_SUBREQUESTS_BY_REQUEST_ID_FAIL,
  LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT,
  LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_SUCCESS,
  LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_FAIL,
} from 'cityads-v3/actions/finance'

export const initialState = {
  filters: {
    // eslint-disable-next-line no-magic-numbers
    added_at: [moment().subtract(7, 'days').startOf('day').toDate().valueOf(), moment().endOf('day').toDate().valueOf()]
  },
  appliedFilters: {
    // eslint-disable-next-line no-magic-numbers
    added_at: [moment().subtract(7, 'days').startOf('day').toDate().valueOf(), moment().endOf('day').toDate().valueOf()]
  },
  subrequestsById: {},
  subrequestsByIdCount: {},
  offerNames: {}
}

export default function finance(state = initialState, action = {}) {
  switch(action.type) {
    case SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filter
        }
      }

    case SET_APPLIED_FILTER:
      return {
        ...state,
        appliedFilters: {
          ...state.filters,
          ...action.filter
        },
        filters: {
          ...state.filters,
          ...action.filter
        }
      }

    case CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          ...initialState.filters,
          perpage: state.filters?.perpage,
          ...(action.filters ?? {})
        },
        appliedFilters: {
          ...initialState.appliedFilters,
          perpage: state.filters?.perpage,
          ...(action.filters ?? {})
        }
      }

    case DELETE_FILTER:
      const afterDeleteFilters = Object.keys(state.appliedFilters)
        .filter(key => key !== action.name)
        .reduce((prev, next) => ({
          ...prev,
          [next]: state.appliedFilters[next]
        }), {})
      return {
        ...state,
        filters: afterDeleteFilters,
        appliedFilters: afterDeleteFilters,
      }

    case DELETE_FILTER_ITEM:
      const afterDeleteFilterItem = state.filters[action.name].filter(value => value !== action.value);
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]: afterDeleteFilterItem
        },
        appliedFilters: {
          ...state.appliedFilters,
          [action.name]: afterDeleteFilterItem
        }
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID:
      return {
        ...state,
        subrequestsById: {
          ...state.subrequestsById,
          [action.additional.id]: {
            ...state.subrequestsById[action.additional.id],
            isLoading: true,
          }
        }
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID_SUCCESS:
      return {
        ...state,
        subrequestsById: {
          ...state.subrequestsById,
          [action.additional.id]: {
            isLoading: false,
            data: action.response.interactedApplication,
            total: action.response.meta.total,
          }
        },
        offerNames: {
          ...state.offerNames,
          ...action.response.offers,
        }
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID_FAIL:
      return {
        ...state,
        subrequestsById: {
          ...state.subrequestsById,
          [action.additional.id]: {
            isLoading: false,
            data: [],
            total: 0,
          }
        }
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT:
      return {
        ...state,
        subrequestsByIdCount: {
          ...state.subrequestsByIdCount,
          [action.additional.id]: 0
        }
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_SUCCESS:
      return {
        ...state,
        subrequestsByIdCount: {
          ...state.subrequestsByIdCount,
          [action.additional.id]: +action.response.total
        },
      }

    case LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_FAIL:
      return {
        ...state,
        subrequestsByIdCount: {
          ...state.subrequestsByIdCount,
          [action.additional.id]: 0
        }
      }

    default:
      return state;

  }
}
